import '../css/Modal.css';
import '../css/FacebookBrowserModalV1.css';
import { openInExternalBrowser } from '../utils/inAppBrowserUtil';
import {
  FACEBOOK_BROWSER_V1_TITLE,
  FACEBOOK_BROWSER_V1_MESSAGE,
  FACEBOOK_BROWSER_OPEN_LABEL,
  FACEBOOK_BROWSER_V1_STAY_LABEL,
} from '../constants/bookingConst';

/**
 * Version 1 of the "Open in your browser" popup (Config -> Theme -> Open in
 * Browser Popup): the original, closable one. A title with ×, a short
 * message, an "Open in Browser" button and a "Keep using Facebook browser"
 * button.
 *
 * "Open in Browser" hands the page to the device's browser
 * (openInExternalBrowser) and does nothing more if that is refused — unlike
 * Version 2 there is no manual-steps guide. × and "Keep using Facebook
 * browser" both dismiss it; a tap outside does not (CLAUDE.md > Behavior).
 *
 * @param {object} props
 * @param {() => void} props.onClose - dismisses the popup
 * @param {() => void} [props.onOpen=openInExternalBrowser] - what "Open in
 *   Browser" does; the preview screens pass a stand-in so it never leaves the page
 * @returns {JSX.Element}
 */
function FacebookBrowserModalV1({ onClose, onOpen = openInExternalBrowser }) {
  return (
    <div className="modal-overlay fbv1-overlay">
      <div className="modal-container fbv1-card" role="dialog" aria-modal="true" aria-labelledby="fbv1-title">
        <div className="modal-header">
          <h2 id="fbv1-title" className="modal-title">{FACEBOOK_BROWSER_V1_TITLE}</h2>
          <button type="button" className="modal-close" onClick={onClose} aria-label="Close">×</button>
        </div>

        <div className="modal-body">
          <p className="modal-message">{FACEBOOK_BROWSER_V1_MESSAGE}</p>
        </div>

        <div className="fbv1-actions">
          <button type="button" className="fbv1-open" onClick={() => onOpen()}>
            {FACEBOOK_BROWSER_OPEN_LABEL}
          </button>
          <button type="button" className="fbv1-stay" onClick={onClose}>
            {FACEBOOK_BROWSER_V1_STAY_LABEL}
          </button>
        </div>
      </div>
    </div>
  );
}

export default FacebookBrowserModalV1;
